import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toggle__label" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "toggle__label-text" }, " on ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "toggle__label-text" }, " off ", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'Toggle',
  props: {
    isOn: { type: Boolean },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:isOn"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:isOn', isOn: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isOn: boolean, disabled: boolean };







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['toggle', { 'toggle--checked': __props.isOn }, { 'toggle--disabled': __props.disabled }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['toggle__slider', { 'toggle__slider--checked': __props.isOn }])
    }, null, 2),
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("input", {
        class: "toggle__checkbox",
        type: "checkbox",
        checked: __props.isOn,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (emits('update:isOn', ($event.target as HTMLInputElement).checked)))
      }, null, 40, _hoisted_2),
      _hoisted_3,
      _hoisted_4
    ])
  ], 2))
}
}

})